import { GroupCowStatus, GroupsStatusTabs } from '../../../models/IGroup'

export const GROUP_STATUS_TABS = [
	{ title: 'Дойные', key: GroupsStatusTabs.Milk },
	{ title: 'Сухостой', key: GroupsStatusTabs.Dry },
	{ title: 'Сухостой 1', key: GroupsStatusTabs.Dry_1 },
	{ title: 'Сухостой 2', key: GroupsStatusTabs.Dry_2 },
	{ title: 'Родильное отделение', key: GroupsStatusTabs.Birthplace },
	{ title: 'Лазарет', key: GroupsStatusTabs.Infirmary },
]

export const mapGroupStatusToTab = (
	status: GroupCowStatus,
): GroupsStatusTabs | null => {
	switch (status) {
		case GroupCowStatus.Milk:
			return GroupsStatusTabs.Milk
		case GroupCowStatus.Dry:
			return GroupsStatusTabs.Dry
		case GroupCowStatus.Dry_1:
			return GroupsStatusTabs.Dry_1
		case GroupCowStatus.Dry_2:
			return GroupsStatusTabs.Dry_2
		case GroupCowStatus.Birthplace:
			return GroupsStatusTabs.Birthplace
		case GroupCowStatus.Infirmary:
			return GroupsStatusTabs.Infirmary
		default:
			return null
	}
}
